import { makeAutoObservable } from "mobx"
import SequencesManager from "react-sdk/haxelibs/SequencesManager"
import { succubus_sequences_Element, succubus_sequences_Sequence } from "react-sdk/haxelibs/sequencesmanagertypes.d.ts";
import SoundPlayer from "react-sdk/SoundPlayer"
import { makeId } from "react-sdk/utils"

export class Dial
{
  /** @type {succubus_sequences_Element} */
  element

  paused
  subtitle
  charRef

  constructor(element) {
    this.element = element

    makeAutoObservable(this)
  }
}

class Dials {
  name = makeId()
  onDialEnd = null

  debugSkip = false

  /** @type {succubus_sequences_Sequence} */
  dialsSequence = null
  currentDialSequenceId = null
  /** @type {Dial} */
  currentDial

  loadedCharIds = new Set()

  loading = false

  constructor(debugSkip = false) {
    console.log("debugSkip", debugSkip)
    this.debugSkip = debugSkip
    makeAutoObservable(this, {
      onDialEnd : false,
      loadedCharIds: false
    })
  }


  addDialFile(fileId) {
    SequencesManager.createFileFromId(fileId);
  }

  deleteAllCharacters() {
    window.SpeechAPI.deleteCharacters(Array.from(this.loadedCharIds))
    this.loadedCharIds = new Set()
  }

  getSequenceChars(filename, sequenceID) {
    let file = SequencesManager.getFile(filename)

    let chars = new Set()
    file.elements
    .filter(el => el.SequenceId === sequenceID)
    .forEach(el => {
      chars.add(el.line.get("Character"))
      if(el.line.get("otherCharacters")) {
        el.line.get("otherCharacters").split(";").forEach(c => chars.add(c))
      }
    })

    return chars
  }

  playSequence(filename, sequenceID, onEnd=null, ) {

    SoundPlayer.playSound("music_dials") // ici on joue les dials

    if(this.debugSkip) {
      // Notifications.neutral("DIAL SEQUENCE " + sequenceID)
      if(onEnd) onEnd()
      return
    }

    if(!SequencesManager.hasSequence(filename, sequenceID)) {
      console.warn("La sequence de dialogue", filename, sequenceID, "n'existe pas")
      if(onEnd) onEnd()
      return
    }
    this.loading = true

    this.onDialEnd = onEnd
    let chars = this.getSequenceChars(filename, sequenceID)

    console.log("loadCharacterIds")
    window.SpeechAPI.loadCharacterIds(Array.from(chars), () => {

      chars.forEach(this.loadedCharIds.add, this.loadedCharIds);

      this.dialsSequence = SequencesManager.playSequence(filename, sequenceID)

      if(this.dialsSequence) {
        this.currentDialSequenceId = sequenceID
        this.nextDial()
      }
      else
        setTimeout(() => {
          this.loading= false
          this.sequenceEnded();
        }, 200);
    })

  }

  /**
   * Permet d'avancer dans la séquence existante
   */
  nextDial()
  {
    if(this.dialsSequence)
      this.dialsSequence.next((seqElement) => {

        if(seqElement) {
          if (this.loading)
              this.loading = false

          this.setDial(seqElement)
        } else {
          this.sequenceEnded()
        }
      })

  }

  setDial(seqElement) {
    this.currentDial = new Dial(seqElement)
  }

  sequenceEnded() {
    this.currentDial = null
    this.currentDialSequenceId = null
    if(this.onDialEnd) {
      let tmp = this.onDialEnd
      this.onDialEnd = null
      tmp()
    }
  }
}


export default Dials